import { ComponentRef, Injectable } from '@angular/core';
import { DataProvidersResolver } from '@epicuro-next/data-providers/providers-registry';

import {
  ResolveValueOptions,
  resolveValues as resolveValuesMethod,
  ResolveValuesOptions,
} from '../utils';

import { ComponentsRelationshipService } from './components-relationship.service';
import { IdProviderServiceFactoryService } from './id-provider-service-factory.service';

@Injectable({ providedIn: 'root' })
export class ResolveValuesService {
  constructor(
    private readonly dataProvidersResolver: DataProvidersResolver,
    private readonly componentsRelationshipService: ComponentsRelationshipService,
    private readonly idProviderServiceFactoryService: IdProviderServiceFactoryService,
  ) {}

  public resolveValues(
    values: Record<string, unknown>,
    componentRef: ComponentRef<unknown>,
    options?: ResolveValueOptions,
    scope?: object,
    isRoot: boolean = false,
  ): { [key: string]: unknown } {
    const idProviderService = this.idProviderServiceFactoryService.get(
      scope ?? (componentRef.instance as object),
      isRoot ?? false,
    );

    return resolveValuesMethod(
      values,
      this.dataProvidersResolver,
      this.componentsRelationshipService,
      idProviderService,
      componentRef,
      options,
    );
  }

  public resolveValue(
    value: unknown,
    componentRef: ComponentRef<unknown>,
    options?: ResolveValuesOptions,
    scope?: object,
    isRoot: boolean = false,
  ): unknown {
    const key = 'key';
    const values = { [key]: value };

    const resolvedValues = this.resolveValues(
      values,
      componentRef,
      options,
      scope,
      isRoot,
    );

    return resolvedValues[key];
  }
}
